import { Link } from 'react-router-dom';
import { site } from '../../content/site';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div>
          <Link to="/" className="footer__brand">
            {site.name}
          </Link>
          <p className="footer__tagline">{site.footer.tagline}</p>
        </div>
        <div className="footer__links">
          <a href={`mailto:${site.contact.email}`}>{site.contact.email}</a>
          <a
            href={site.contact.linkedin}
            target="_blank"
            rel="noreferrer noopener"
          >
            LinkedIn ↗
          </a>
        </div>
      </div>
      <div className="container footer__legal">{site.footer.copyright}</div>
    </footer>
  );
}
